<template>
  <div>
    <Navbar />
    <el-table
        :data="fundData"
        style="width: 100%"
        border
        stripe
    >
      <el-table-column
          prop="code"
          label="代码"
          width="80"
      ></el-table-column>
      <el-table-column
          prop="name"
          label="基金名称"
          width="180"
      ></el-table-column>
      <el-table-column
          prop="real_time估值"
          label="实时估值"
          width="120"
      ></el-table-column>
      <el-table-column
          prop="real_time溢价"
          label="实时溢价"
          width="120"
      ></el-table-column>
      <el-table-column
          prop="current_price"
          label="当前价格"
          width="120"
      ></el-table-column>
      <el-table-column
          prop="price_change"
          label="价格变动"
          width="120"
      ></el-table-column>
      <el-table-column
          prop="transaction_volume"
          label="交易量"
          width="120"
      ></el-table-column>
      <el-table-column
          prop="market_share"
          label="市场份额"
          width="120"
      ></el-table-column>
      <el-table-column
          prop="new_shares"
          label="新份额"
          width="120"
      ></el-table-column>
      <el-table-column
          prop="net_value"
          label="净值"
          width="120"
      ></el-table-column>
      <el-table-column
          prop="net_value_change"
          label="净值变动"
          width="120"
      ></el-table-column>
      <el-table-column
          prop="index_change"
          label="指数变动"
          width="120"
      ></el-table-column>
      <el-table-column
          prop="subscription_limit"
          label="申购限额"
          width="120"
      ></el-table-column>
      <el-table-column
          prop="subscription_fee"
          label="申购费"
          width="120"
      ></el-table-column>
      <el-table-column
          prop="redemption_fee"
          label="赎回费"
          width="120"
      ></el-table-column>
      <el-table-column
          prop="other"
          label="其他"
          width="180"
      ></el-table-column>
    </el-table>


    <div class="container">
      <!-- 页面内容 -->
    </div>
    <Footer />
  </div>
</template>

<script>
import axios from "axios";
import Navbar from './NavigationBar .vue'
import Footer from './Footer.vue'

export default {
  components: {
    Navbar,
    Footer
  },
  data() {
    return {
      fundData: []
    };
  },
  methods: {
    fetchFundData() {
      axios.get('http://127.0.0.1:8000/arbitrage/fundestimate').then(response => {
        this.fundData = response.data;
      }).catch(error => {
        console.error('Error fetching fund data:', error);
      });
    }
  },
  mounted() {
    this.fetchFundData();
  }
};
</script>